import getApiClient from '@/plugins/api-client'

export default {
    loadMessages(silent = false) {
        const self = this,
            api = getApiClient(self.$store)

        if (!silent) {
            self.$store.commit('startLoading')
        }

        api.get('/messages', {
            params: {
                'job.id': self.jobId,
                'recipient.id': [self.recipientId, self.userId],
            }
        })
            .then(result => {
                self.messages = result.data['hydra:member']
                self.$root.$emit('messagesRead')

                const hubUrl = result.headers.link.match(/<([^>]+)>;\s+rel=(?:mercure|"[^"]*mercure[^"]*")/)[1],
                    subscribeURL = `${hubUrl}?topic=messages_${self.$store.state.session.user.id}&topic=messages_sent_${self.$store.state.session.user.id}`

                self.eventSource = new EventSource(subscribeURL, {withCredentials: true})

                self.eventSource.onmessage = ({data}) => {
                    const update = JSON.parse(data),
                        messageAlreadyAdded = self.messages.filter(message => {
                            return message.id === update.id
                        }).length > 0

                    if (!update.read && [self.recipientId, self.userId].includes(update.recipient.id) && !messageAlreadyAdded) {
                        if (update.recipient.id === self.userId && self.eventSource.readyState === self.eventSource.OPEN) {
                            api.get(update['@id']).catch(() => {
                            })
                        }
                        self.messages.push(update)
                    }
                }
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                if (!silent) {
                    self.$store.commit('stopLoading')
                }
            })
    },

    sendMessage() {
        const self = this,
            api = getApiClient(self.$store)

        api.post('/messages', {
            content: self.currentMessage,
            recipient: `/users/${self.recipientId}`,
            job: `/jobs/${self.jobId}`
        })
            .then(() => {
                self.loadMessages()
                self.currentMessage = ''
            })
            .catch(error => {
                console.log(error)
            })
    }
}
